
import "@glidejs/glide/dist/css/glide.core.min.css";

export default {
  props: {
    title: {
      type: String,
      default:
        "Les avis des clients ALEO, votre agence de communication digitale",
    },
    reviews: {
      type: Array,
      default: () => {
        return [
          {
            text: "Je recommande cette agence de com, ils font du bon travail, Malik est très professionnel et effectue un bon suivi.",
            author: "Soc Qualité",
          },
          {
            text: "Je recommande cette agence de com, ils font du bon travail, Malik est très professionnel et effectue un bon suivi.",
            author: "Soc Qualité",
          },
          {
            text: "Je recommande cette agence de com, ils font du bon travail, Malik est très professionnel et effectue un bon suivi.",
            author: "Soc Qualité",
          },
          {
            text: "Je recommande cette agence de com, ils font du bon travail, Malik est très professionnel et effectue un bon suivi.",
            author: "Soc Qualité",
          },
        ];
      },
    },
    isResults: {
      type: Boolean,
      default: false,
    },
    results: {
      type: Array,
      default: () => {
        return [
          {
            img: "results-4.png",
            alt: "resultat rapide",
            title: "En première position sur “Couvreur 93”",
            society: "AMC Couverture",
            tags: "Artisan Couvreur — Aulnay-sous-Bois",
          },
          {
            img: "results-5.png",
            alt: "resultat rapide",
            title: "1ère position sur “Médecin esthétique Nancy”",
            society: "CMEG",
            tags: "Médecine Esthétique — Nancy",
          },
          {
            img: "results-6.png",
            alt: "resultat rapide",
            title: "TOP 3 Google sur son activité",
            society: "A2 Services",
            tags: "Nettoyage et entretien — Sarrebourg",
          },
        ];
      },
    },

    cases: {
      type: Array,
      default: () => {
        return [
          {
            author: "Chrystelle Martin - Gérante",
            text: "Une équipe très réactive qui a pris en main mes campagnes réseaux sociaux avec agilité. L'expérience et la convivialité d'Aurore, notre attaché de compte est un vrai plus.",
            img: "case-studies/post-fb-faute-voltaire.jpg",
            link: "la-faute-a-voltaire",
            alt: "La Faute à Voltaire",
          },
          {
            author: "ELSA DUBOIS - Gérante CMEG",
            text: "ALEO m'accompagne dans le développement de mon cabinet depuis plus d'un an. Leur professionnalisme et leur réactivité m'ont permis de démarrer sereinement mon activité. Je recommande à 100 %.",
            img: "case-studies/cmeg-sw.jpg",
            link: "cmeg",
            alt: "Projet client ALEO - Site internet",
          },
        ];
      },
    },
  },

  mounted() {
    this.initGlide();
  },

  methods: {
    initGlide() {
      const getGlide = () => import("@glidejs/glide/dist/glide.modular.esm");

      getGlide().then(
        ({ default: Glide, Swipe, Controls, Autoplay, Breakpoints }) => {
          if (
            this.itMatchMedia("(max-width: 1023px)" && this.isResults === true)
          ) {
            new Glide(".glide-results", {
              type: "carousel",

              rewind: false,
              breakpoints: {
                1024: {
                  perView: 1.8,
                  gap: 40,
                },
                768: {
                  perView: 1.2,
                  gap: 40,
                },
              },
            }).mount({ Swipe, Controls, Breakpoints });
          }
          new Glide("#glide-expert", {
            type: "carousel",
            perView: 1.4,
            gap: 40,
            rewind: false,
            focusAt: "center",
            breakpoints: {
              1024: {
                perView: 1,
              },
            },
          }).mount({ Swipe, Controls, Breakpoints });

          const glideReviews = new Glide(".wrapper-reviews ", {
            type: "carousel",
            perView: 4,
            gap: 16,
            // autoplay: 3000,
            rewind: false,
            breakpoints: {
              768: {
                perView: 1.2,
              },
              1024: {
                perView: 2.2,
              },
            },
          }).mount({ Swipe, Breakpoints, Autoplay });

          if (this.itMatchMedia("(min-width: 1024px)")) {
            glideReviews.disable();
          } else {
            glideReviews.enable();
          }

          window
            .matchMedia("(min-width: 1024px)")
            .addEventListener("change", (event) => {
              if (event.matches) {
                glideReviews.disable();
              } else {
                glideReviews.enable();
              }
            });
        }
      );
    },

    itMatchMedia(media) {
      return window.matchMedia(media).matches;
    },
  },
};
